import TicketAttribute from '../ticket-attribute/ticket-attribute.model';

export default class TicketAttributeValue {
    public id = '';
    public value = [];
    public name = '';
    public ticketAttribute: TicketAttribute = new TicketAttribute();

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.value) {
            this.value = model.value;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.ticketAttribute) {
            this.ticketAttribute = new TicketAttribute(model.ticketAttribute);
        }
    }
}
